<script setup lang="ts">

import StandardCard from '@/components/Elements/Cards/StandardCard.vue'
import { CDN } from '@/models/cdn.ts'
import { useRouteStore } from '@/stores/routeStore.ts'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const routeStore = useRouteStore()

/**
 * Props
 */
const props = defineProps<{
  shipActionData: {
    action: string;
    targetX: number;
    targetY: number;
    targetPlayer: number;
    targetShip: number;
    routeId?: number;
    data: {
      name?: string;
      type: number;
      typeVariantId: number;
      targetPlayer: number;
    }
  },
  eta: number
}>();

const routeName = computed(() => {
  if (props.shipActionData.routeId) {
    const route = routeStore.findRouteById(props.shipActionData.routeId)
    return route?.name || t('command.ships.current.unknownRoute')
  }
  return props.shipActionData.data?.name || t('command.ships.current.unknownRoute')
})

</script>

<template>
  <StandardCard top-padding="0" bottom-padding="1">
    <div class="flex justify-between text-subtext w-full">
      <div class="flex gap-4">
        <img :src="CDN.icon32('patrol')" :alt="t('command.ships.current.patrol.tooltip')" :title="t('command.ships.current.patrol.tooltip')" class="hidden md:inline w-5 h-5"/>
        <div class="flex items-center">
          <span>{{ t('command.ships.current.patrol.patrollingRoute', { name: routeName }) }}</span>
        </div>
      </div>
      <div class="flex-shrink-0 ps-2">

      </div>
    </div>
  </StandardCard>
</template>

<style scoped lang="scss">

</style>